import Image from "next/image";
import Link from "next/link";

const MainCategories = ({ categories, locale }) => {
    const defaultNoImage = '/noImageWiki.png';

    return (
        <div>
            <div className="grid lg:grid-cols-3 gap-x-4 gap-y-8">
                {categories?.slice(0, 6).map((item, index) => {
                    return (
                        <Link key={index} href={`/${locale === "tr" ? 'yardim' : 'help'}/${item.slug}`}>
                            <div className="p-4 space-y-4 border border-black cursor-pointer rounded-2xl">
                                <div className="flex justify-center">
                                    <Image
                                        src={item.img ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + item.img : defaultNoImage}
                                        title={item.image_title}
                                        alt={item.image_description}
                                        width={245}
                                        height={155}
                                        quality={100}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultNoImage
                                            currentTarget.srcset = defaultNoImage
                                        }}
                                    />
                                </div>
                                <h2 className="text-lg font-semibold text-black">{item.title}</h2>

                                <p className="text-black">{item.description}</p>
                            </div>
                        </Link>
                    )
                })}
            </div>

            <div className="grid grid-cols-2 gap-4 pt-8">
                {categories.slice(6, 8).map((item, index) => {
                    return (
                        <div key={index} className="p-4 space-y-4 border border-black cursor-pointer rounded-2xl">
                            <div className="flex justify-center">
                                <Image
                                    src={item.img ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + item.img : defaultNoImage}
                                    title={item.image_title}
                                    alt={item.image_description}
                                    width={245}
                                    height={155}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = defaultNoImage
                                        currentTarget.srcset = defaultNoImage
                                    }}
                                />
                            </div>
                            <h2 className="text-lg font-semibold text-black">{item.title}</h2>

                            <p className="text-black">{item.description}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default MainCategories